import NavButtons from '../components/NavButtons';
import ContentBlocks from '../components/ContentBlocks';

function ContentScreen({ heading, blocks, onBack, onNext, showBack = true, showNext = true }) {
  return (
    <div className="screen">
      <div className="screen-content">
        <h1 className="screen-title">{heading}</h1>
        <ContentBlocks blocks={blocks} />
      </div>
      <NavButtons onBack={onBack} onNext={onNext} showBack={showBack} showNext={showNext} />
    </div>
  );
}

export default ContentScreen;